// extracted by mini-css-extract-plugin
export var cardSelected = "_hb-2";
export var image = "_hb-1";
export var table = "_hb-0";